import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { currencies } from '../currencyExchangeRule';
import { LOYALTY } from '../credential';
export default fillCrudMetadataGaps({
  label: 'Configuração de Fidelidade - Acúmulo',
  labelPlural: 'Configurações de Fidelidade - Acúmulo',
  name: 'LoyaltyConfiguration',
  deletable: false,
  updatable: true,
  insertable: true,
  custom_withAudit: true,
  custom_blockRecord: true,
  authorization: authorization('clientConsultant', 'admin'),
  dynamoDB: {
    tableName: 'SpearLoyaltyConfiguration'
  },
  columnNames: ['id', 'name', 'enabled'],
  i18n_enabled: true,
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    render: false,
    id: true
  }, {
    label: 'Nome',
    name: 'name',
    type: 'text'
  }, {
    label: 'Ativo',
    name: 'enabled',
    type: 'boolean'
  }, {
    custom_groupName: 'Tipo de Fidelidade',
    name: 'loyaltyType',
    label: 'Tipo de fidelidade',
    type: 'text',
    options: [{
      value: 'CASHBACK',
      label: 'Cashback'
    }, {
      value: 'POINTS',
      label: 'Pontos'
    }]
  }, {
    custom_groupName: 'Tipo de Fidelidade',
    name: 'currency',
    label: 'Moeda',
    type: 'text',
    inputType: 'select',
    options: currencies,
    conditionalRequired: e => e.loyaltyType === 'CASHBACK',
    renderForm: e => e.loyaltyType === 'CASHBACK'
  }, {
    custom_groupName: 'Tipo de Fidelidade',
    name: 'loyaltyCredentialId',
    label: 'Parceiro de fidelidade',
    inputType: 'credential',
    credentialTypeList: LOYALTY,
    custom_nameField: 'points_loyaltyCredentialName'
  }, {
    custom_groupName: 'Tipo de Fidelidade',
    name: 'points_loyaltyCredentialName',
    label: 'Credencial de fidelidade',
    renderForm: false
  }, {
    custom_groupName: 'Tipo de Fidelidade',
    name: 'costPerPoints',
    label: 'Custo por ponto',
    type: 'float',
    renderForm: function (i) {
      return i.loyaltyType && i.loyaltyType === 'POINTS' ? this.render && this.render(i) : false;
    }
  }, {
    custom_groupName: 'Valor Base',
    hint: 'Para calcular a quantidade de cashback/pontos acumulados para uma reserva - proporcional ao valor total da reserva, do número de noites ou do valor da comissão',
    label: 'Base',
    name: 'reference',
    type: 'text',
    options: [{
      value: 'RESERVATION',
      label: '% do valor da reserva'
    }, {
      value: 'RESERVATION_WITHOUT_TAXES',
      label: '% do valor da reserva sem taxas'
    }, {
      value: 'NIGHT',
      label: 'proporcional ao número de diárias'
    }]
  }, {
    custom_groupName: 'Valor Base',
    hint: 'Ex 1: Se 1 diária = 1 ponto, colocar 100%.',
    label: '% Base',
    name: 'referenceShare',
    inputType: 'percentage',
    type: 'float'
  }, {
    custom_groupName: 'Valor Base',
    label: 'Permitir acúmulo de pontos + dinheiro',
    hint: 'Se desabilitado, em reservas com uso de pontos não é feito acúmulo para a pessoa. Se habilitado, em uma mesma reserva é permitido usar pontos para ganhar desconto E acumular pontos sobre o valor pago.',
    name: 'allowRewardWithPoints',
    type: 'boolean',
    default: false
  }, {
    custom_groupName: 'Regra Transferência',
    label: 'Data base',
    hint: 'Evento que vai ser usado para agendar o acúmulo dos pontos/cashback (reserva, início da reserva, checkout da reserva, checkout realizado (apenas quando há integração com PMS do hotel).',
    name: 'paymentDate',
    type: 'text',
    options: [{
      value: 'RESERVATION',
      label: 'Reserva'
    }, {
      value: 'CHECKIN',
      label: 'Checkin'
    }, {
      value: 'CHECKOUT',
      label: 'Checkout'
    }, {
      value: 'REAL_CHECKOUT',
      label: 'Checkout Realizado'
    }]
  }, {
    custom_groupName: 'Regra Transferência',
    label: 'Dias',
    hint: 'Quantos dias depois da data base será feito o acúmulo dos pontos/cashback',
    name: 'cashback_paymentDateOffset',
    type: 'int'
  }, {
    custom_groupName: 'Textos',
    label: '-',
    name: 'highlightText',
    deprecated: true,
    // Nome não quer dizer nada. Qual a diferença entre informativeText, highlightText e descriptionText? Substituir por campos com nomes que significam alguma coisa. #
    renderForm: false
  }, {
    custom_groupName: 'Textos',
    label: '-',
    name: 'informativeText',
    deprecated: true,
    // Nome não quer dizer nada. Qual a diferença entre informativeText, highlightText e descriptionText? Substituir por campos com nomes que significam alguma coisa. #
    renderForm: false
  }, {
    custom_groupName: 'Textos',
    label: 'Unidade',
    name: 'unitText',
    i18n_enabled: true
  }, {
    custom_groupName: 'Textos',
    label: '-',
    name: 'descriptionText',
    deprecated: true,
    // Nome não quer dizer nada. Qual a diferença entre informativeText, highlightText e descriptionText? Substituir por campos com nomes que significam alguma coisa. #
    renderForm: false
  }, {
    custom_groupName: 'Textos',
    label: 'Logotipo pequeno',
    inputType: 'inputPublicFile',
    name: 'smallLogo',
    fileType: 'images',
    custom_gerarPrefix: i => {
      return 'loyaltyPrograms/' + i.id + '/logo/';
    },
    hint: 'Para exibição em e-mail. Tamanho sugerido: 80px x 80px.'
  }, {
    custom_groupName: 'Conversão de Pontos',
    name: 'allowDecimals',
    label: 'Permite apresentação de casas decimais',
    type: 'boolean',
    hint: 'Desmarcar se pontos sem casas decimais (ex: diárias)',
    default: true,
    renderForm: function (i) {
      return i.loyaltyType && i.loyaltyType === 'POINTS' ? this.render && this.render(i) : false;
    }
  }, {
    custom_groupName: 'Conversão de Pontos',
    name: 'decimalsRoundingPolicy',
    label: 'Tipo de arredondamento',
    type: 'text',
    options: [{
      value: 'ROUND',
      label: 'Padrão'
    }, {
      value: 'FLOOR',
      label: 'Para baixo'
    }, {
      value: 'CEIL',
      label: 'Para cima'
    }],
    default: 'ROUND',
    renderForm: function (i) {
      return i.loyaltyType && i.loyaltyType === 'POINTS' && i.allowDecimals === false ? this.render && this.render(i) : false;
    }
  }, {
    custom_groupName: 'Conversão de Pontos',
    label: 'Usar custo do ponto',
    name: 'useCostPerPoints',
    type: 'boolean',
    default: true,
    renderForm: function (i) {
      return i.loyaltyType && i.loyaltyType === 'POINTS' ? this.render && this.render(i) : false;
    }
  }, {
    custom_groupName: 'Conversão de Pontos',
    label: 'Moeda Conversão',
    name: 'pointsConversion',
    type: 'objectarray',
    graphQLType: '[LoyaltyCurrencyListItem]',
    graphQLInputType: '[LoyaltyCurrencyListItemInput]',
    fields: [{
      name: 'currency',
      label: 'Moeda',
      inputType: 'select',
      options: [{
        value: 'BRL',
        label: 'Reais (BRL)'
      }, {
        value: 'USD',
        label: 'Dólar (USD)'
      }, {
        value: 'EUR',
        label: 'Euro (EUR)'
      }]
    }, {
      name: 'value',
      label: 'Valor de 1 ponto na moeda escolhida',
      type: 'float'
    }],
    renderForm: function (i) {
      return i.loyaltyType && i.loyaltyType === 'POINTS' && !i.useCostPerPoints ? this.render && this.render(i) : false;
    }
  }, {
    custom_groupName: 'Configurações de exibição',
    name: 'showTierOnNavbar',
    label: 'Mostrar nível na barra de navegação',
    type: 'boolean',
    renderForm: function (i) {
      return i.loyaltyCredentialId ? this.render && this.render(i) : false;
    }
  }, {
    custom_groupName: 'Configurações de exibição',
    name: 'hideReward',
    label: 'Ocultar exibição do acúmulo/saldo no resultado da busca, checkout, minhas viagens e voucher',
    type: 'boolean',
    renderForm: function (i) {
      return i.loyaltyCredentialId ? this.render && this.render(i) : false;
    }
  }],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }]
});